import { render, staticRenderFns } from "./NewInvite.vue?vue&type=template&id=99796314&scoped=true&"
import script from "./NewInvite.vue?vue&type=script&lang=js&"
export * from "./NewInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99796314",
  null
  
)

export default component.exports